import { RecordLink } from 'components/record-chip/RecordLink';
import { FormattedMessage } from 'react-intl';

type PageHeaderLinkProps = {
    labelId: string;
    link: string;
    id: string | number;
    name?: string;
};
export const PageHeaderLink = ({ labelId, link, name, id }: PageHeaderLinkProps) => (
    <div className="flex items-center gap-[5px] text-xs leading-5 font-medium">
        <FormattedMessage id={labelId} />
        :&nbsp;
        <RecordLink className="text-link no-underline hover:underline" to={`/${link}/${id}`} label={name ?? '-'} />
    </div>
);
